export const TAG_MULT = {
  id: 1,
  name: 'tagMult',
  bg: 'bg-purple',
  color: 'text-white',
} as const

export const TAG_ARITHMETIC = {
  id: 2,
  name: 'tagArithmetic',
  bg: 'bg-purple',
  color: 'text-white',
} as const

export const TAG_FRACTION = {
  id: 3,
  name: 'tagFraction',
  bg: 'bg-purple',
  color: 'text-white',
} as const

export const TAG_NEW = {
  id: 4,
  name: 'tagNew',
  bg: 'bg-gradient-to-r from-red to-orange',
  color: 'text-white',
  iconName: 'icons/stars.svg',
} as const

export const TAG_ADDITION = {
  id: 5,
  name: 'tagAddition',
  bg: 'bg-purple',
  color: 'text-white',
} as const

export const TAG_DIVISION = {
  id: 6,
  name: 'tagDivision',
  bg: 'bg-purple',
  color: 'text-white',
} as const

export const TAG_NUMBERS_AND_QUANTITIES = {
  id: 7,
  name: 'tagNumbersAndQuantities',
  bg: 'bg-purple',
  color: 'text-white',
} as const

export const TAG_STATISTICS = {
  id: 8,
  name: 'tagStatistics',
  bg: 'bg-purple',
  color: 'text-white',
} as const

export const TAG_GEOMETRY = {
  id: 9,
  name: 'tagGeometry',
  bg: 'bg-purple',
  color: 'text-white',
} as const

export enum TREASURETRAIL_REQUEST {
  REQUEST = 'request',
  INITIAL_DATA = 'initialData',
  HIDE_BANNER = 'hideBanner',
  SHOW_BANNER = 'showBanner',
  GET_USERDATA = 'getUserStats',
  SET_USERDATA = 'setUserStats',
  MAKE_AVATAR = 'makeAvatar',
  PLAYCANVAS_ANALYTICS_EVENT = 'playcanvasAnalyticsEvent',
}

export enum WINDSURFER_REQUEST {
  REQUEST = 'request',
  INITIAL_DATA = 'initialData',
  GET_USERDATA = 'getUserStats',
  SET_USERDATA = 'setUserStats',
  HIDE_BANNER = 'hideBanner',
  SHOW_BANNER = 'showBanner',
  MAKE_AVATAR = 'makeAvatar',
  PLAYCANVAS_ANALYTICS_EVENT = 'playcanvasAnalyticsEvent',
}

export enum GAME_REWARDS {
  KUDOS = 'giveKudos',
  GEMS = 'giveGems',
  XP = 'giveXP',
}
